var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[_vm.b({ select: _vm.select }), 'om-hairline'],attrs:{"href":_vm.url},on:{"click":_vm.onClick}},[(_vm.isDef(_vm.info))?_c('div',{class:_vm.b('info')},[_vm._v(_vm._s(_vm.info))]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c705f7d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/jscom/omui/components/badge/index.vue
// module id = vHqz
// module chunks = 76